import { createTheme } from '@mui/material/styles';

// Custom colors
const customColors = {
  purple: '#5e2870',
  yellow: '#e19d38',
  green: '#6f894f',
  blue: '#506eb0',
};

// MUI theme
const theme = createTheme({
  palette: {
    primary: {
      main: customColors.purple,
    },
    secondary: {
      main: customColors.yellow,
    },
    success: {
      main: customColors.green,
    },
    info: {
      main: customColors.blue,
    },
  },
  typography: {
    fontFamily: 'ObjektivMk3W, Arial, sans-serif',
    fontWeightHairline: 100,
    fontWeightThin: 200,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
    fontWeightExtraBold: 800,
  },
  colors: customColors, // optional for direct access in your components
});

export default theme;
